import moment from "moment";
import React from "react";
import { LiaArrowAltCircleUpSolid } from "react-icons/lia";
import P from "../../../shared/typography/P";
import PaymentStatus from "./PaymentStatus";

const PaymentHistory = ({ data, onUpdate }) => {
    return (
        <div className="overflow-x-auto h-full">
            {data?.length === 0 ? (
                <div className="bg-red/5 border-red px-2 py-1 text-center border rounded ">
                    <P className="font-vietnam text-red ">
                        Payments history not available
                    </P>
                </div>
            ) : (
                data.map((item) => (
                    <div
                        key={item.id}
                        className="flex items-center gap-1 pb-1.5 mb-1.5 border-b border-blue-300"
                    >
                        <div className="flex items-center justify-center h-3 w-3 bg-gray-60 rounded-full">
                            <LiaArrowAltCircleUpSolid className="text-xxl text-gray-500" />
                        </div>
                        <div className="flex-1">
                            <div className="flex justify-between items-center">
                                <P className="text-primary xl:text-sm 2xl:text-sm">
                                    {item?.paymentReceiptName}
                                </P>
                                <PaymentStatus
                                    status={item?.paymentStatus?.toLowerCase()}
                                    statusType={
                                        item?.paymentStatus === "PAID"
                                            ? "success"
                                            : "warn"
                                    }
                                />
                            </div>
                            <P className="text-gray-370 !text-xs">
                                Payment Id #{item.paymentId}
                            </P>
                            <div className="  flex gap-1 justify-between items-center">
                                <div>
                                    <P className="text-gray-370 !text-xs">
                                        {moment(item.paymentAt * 1000).format(
                                            "DD/MM/yyyy"
                                        )}
                                    </P>
                                </div>
                                <div>
                                    <P className="xl:text-sm 2xl:text-sm">
                                        ₹ {item.amount}
                                    </P>
                                </div>
                            </div>
                            {onUpdate && item?.paymentStatus === "PENDING" && (
                                <div>
                                    <button
                                        className="text-blue text-xs underline mt-0.2"
                                        onClick={() => onUpdate(item)}
                                    >
                                        Approve Payment
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default PaymentHistory;
